import React from 'react';
import './HeroSection.scss';
import ParticlesView from '../ParticlesView/ParticlesView';
import HeroButton from '../../../Library/HeroButton/HeroButton';

import { homePage } from '../../../editable-stuff/config';

export default function HeroSection() {
  return (
    <section id='hero'>
      <ParticlesView />
      <div className='lines cover'></div>
      <div className='content max-1100'>
        <h1>{homePage.hero?.title}</h1>
        <p>{homePage.hero?.subtext}</p>
        <div className='buttons'>
          {homePage.hero?.buttons.map((btn) => (
            <HeroButton link={btn.link} text={btn.title} icon={btn.icon} />
          ))}
        </div>
      </div>
      <div className='wave-bottom'>
        <svg
          fill='#ffffff'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 100'
          preserveAspectRatio='none'
        >
          <path d='M 0 14 s 88.64 3.48 300 36 c 260 40 514 27 703 -10 l 12 28 l 3 36 h -1018 z'></path>
          <path d='M 0 45 s 271 45.13 500 32 c 157 -9 330 -47 515 -63 v 86 h -1015 z'></path>
          <path d='M 0 58 s 188.29 32 508 32 c 290 0 494 -35 494 -35 v 45 h -1002 z'></path>
        </svg>
      </div>
    </section>
  );
}
